import React, { CSSProperties } from 'react';
import { Button, DrawFeature, DrawSetting, Sprite } from '@agissc/ktag-map';
import { useTranslation } from 'react-i18next';
import useDrawListElementFn from './useDrawListElementFn';

const getFeatureTool = (feature: DrawFeature) => {
  const { type } = feature.properties;

  switch (type) {
    case 'dot':
      return {
        icon: 'dot-outline',
        toolI18nKey: 'draw_tool_dot',
      };
    case 'line':
      return {
        icon: 'stroke',
        toolI18nKey: 'draw_tool_line',
      };
    case 'polygon':
      return {
        icon: 'polygon',
        toolI18nKey: 'draw_tool_polygon',
      };
    case 'arrow':
      return {
        icon: 'internal',
        toolI18nKey: 'draw_tool_arrow',
      };
    case 'circle':
      return {
        icon: 'circle',
        toolI18nKey: 'draw_tool_circle',
      };
    case 'text':
      return {
        icon: 'text-a',
        toolI18nKey: 'draw_tool_text',
      };
    default:
      return {
        icon: '',
        toolI18nKey: '',
      };
  }
};

interface Props {
  feature: DrawFeature;
  isHovered?: boolean;
}

const DrawListTool = ({ feature, isHovered }: Props) => {
  const { t } = useTranslation('agisviewer');
  const { icon, toolI18nKey } = getFeatureTool(feature);

  const { onSelectFeature } = useDrawListElementFn(feature);

  return (
    <Button
      additionalClassNames={`draw-list__tool ${isHovered ? 'draw-list__tool--hovered' : ''}`}
      onClick={onSelectFeature}
    >
      <Sprite id={icon} additionalClassNames="draw-list__icon" />
      <span
        className="draw-list__tool-color"
        style={
          {
            '--tool-color': feature.properties.settings[DrawSetting.Color],
          } as CSSProperties
        }
      />
      <span className="draw-list__tool-name">{t(toolI18nKey)}</span>
    </Button>
  );
};

export default DrawListTool;
